import { Button, Form, Image, } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/features/auth/thunk";
import { validateEmail } from "../../utils/validations/validations";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [passwordErr, setpasswordErr] = useState("");
  const dispatch = useDispatch();
  let navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault()
    let emailMsg = "";
    let passwordMsg = "";
    let check = true;
    if (email === "") {
      emailMsg = "Email is Required"
      check = false;
    } else {
      emailMsg = validateEmail(email);
      if (emailMsg) check = false;
    }
    if (password === "") {
      passwordMsg = "Password is required"
      check = false;
    }
    setEmailErr(emailMsg);
    setpasswordErr(passwordMsg);
    if (check) {
      let payload = {
        email: email,
        userPassword: password
      }
      dispatch(login(payload))
      navigate('/')
    }
  };



  return (
    <>
      <Form>
        <div class="form-group">
          <Form.Label for="exampleInputEmail1">Email address</Form.Label>
          <Form.Control  type="email"
                        onChange={(event) => {
                          setEmail(event.target.value);
                        }}
                        value={email} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
        </div>
        <div class="form-group">
          <Form.Label for="exampleInputPassword1">Password</Form.Label>
          <Form.Control type="password" onChange={(event) => {
                        setPassword(event.target.value);
                      }}
                        value={password} class="form-control" id="exampleInputPassword1" placeholder="Password" />
        </div>
        <Button type="submit" onClick={(e) => handleSubmit(e)} class="btn btn-primary">Login</Button>
        <Link to={'/register'}>Signup</Link>
      </Form>
    </>

  );
};

export default Login;